(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[224],{

/***/ 1740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/highlight/[slug]",
      function () {
        return __webpack_require__(9828);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5641);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9305);
/* harmony import */ var _ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4__);






function ArticlesRelated(param) {
    var articles = param.articles, className = param.className, wrapperClassName = param.wrapperClassName;
    if (articles === null || articles.length < 1) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().container), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().wrapper), wrapperClassName),
            children: articles.filter(function(f) {
                return f.acfPost.featuredImage !== null;
            }).map(function(param) {
                var slug = param.slug, title = param.title, acfPost = param.acfPost, acfPostSettings = param.acfPostSettings;
                var ref, ref1, ref2;
                var setRelatedModels = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : (ref = acfPostSettings.relatedModels) === null || ref === void 0 ? void 0 : ref.map(function(rm) {
                    return rm.title;
                }).join(", ").replace(/,(?!.*,)/gim, " &");
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: slug,
                    type: "Article",
                    className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().project),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().imgWrap),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                images: [
                                    {
                                        url: acfPost === null || acfPost === void 0 ? void 0 : (ref1 = acfPost.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl,
                                        params: "w_510,f_auto"
                                    },
                                    {
                                        url: acfPost === null || acfPost === void 0 ? void 0 : (ref2 = acfPost.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl,
                                        params: "w_445,f_auto"
                                    }, 
                                ],
                                className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().img)
                            })
                        }),
                        setRelatedModels && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().title),
                            dangerouslySetInnerHTML: {
                                __html: setRelatedModels
                            }
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                            dangerouslySetInnerHTML: {
                                __html: title.substr(0, title.lastIndexOf("|")) || title
                            }
                        })
                    ]
                }, slug);
            })
        })
    });
}
ArticlesRelated.propTypes = {
    articles: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().array),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    wrapperClassName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
ArticlesRelated.defaultProps = {
    articles: [],
    className: "",
    wrapperClassName: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticlesRelated);


/***/ }),

/***/ 6653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(662);
/* harmony import */ var hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(698);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5641);
/* harmony import */ var components_SliderBlock__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8115);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2657);
/* harmony import */ var _SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7764);
/* harmony import */ var _SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10__);












function SliderCover(param) {
    var title = param.title, covers = param.covers, coverTitle = param.coverTitle, noLink = param.noLink, className = param.className;
    var ref;
    if ((covers === null || covers === void 0 ? void 0 : covers.length) < 0) return null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), timeoutId = ref2[0], setTimeoutId = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), locationTimeoutId = ref3[0], setLocationTimeoutId = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), videoTimeoutId = ref4[0], setVideoTimeoutId = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sliderColour = ref5[0], setSliderColour = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sliderMobileColour = ref6[0], setSliderMobileColour = ref6[1];
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var setSliderLength = covers.length;
    var windowSize = (0,hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var isDesktop = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) >= 900;
    var isMobile = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 900;
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(timeoutId);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(locationTimeoutId);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(videoTimeoutId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var doc = document.documentElement;
        var headerAttr = "data-header-color";
        if (isMobile && (router.pathname === "/[site]/[boardType]" || router.pathname === "/[site]/[boardType]/[boardSlug]") || isMobile && sliderMobileColour === "dark") {
            doc.setAttribute(headerAttr, "dark");
        } else if (isMobile && sliderMobileColour === "light" || isDesktop && sliderColour === "light") {
            doc.setAttribute(headerAttr, "light");
        } else if (isDesktop && sliderColour === "light-dark-logo") {
            doc.setAttribute(headerAttr, "light-ui-dark-logo");
        } else if (isDesktop && sliderColour === "dark-light-logo") {
            doc.setAttribute(headerAttr, "dark-ui-light-logo");
        }
        return function() {
            doc.removeAttribute(headerAttr);
        };
    }, [
        isMobile,
        sliderColour,
        sliderMobileColour
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        //TODO: Quickly added a random timeout to try and play videos
        // after a location change. Need to find a proper way to resolve
        // when time is allocated
        return function() {
            var locationTimeoutId = setTimeout(function() {
                playVideo();
            }, 2000);
            setLocationTimeoutId(locationTimeoutId);
        };
    }, [
        router
    ]);
    var sliderSettings = {
        fade: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        onInit: function() {
            var ref, ref1;
            // NOTE: Arbitrary timeout set here. Can we get the video before slider
            // init as it is firing before?
            var timeoutId = setTimeout(function() {
                playVideo();
            }, 1000);
            setTimeoutId(timeoutId);
            if ((ref = covers === null || covers === void 0 ? void 0 : covers[0].acfHighlightCover) === null || ref === void 0 ? void 0 : (ref1 = ref.covers) === null || ref1 === void 0 ? void 0 : ref1.length) {
                var ref2, ref3;
                var ref4 = (ref2 = covers === null || covers === void 0 ? void 0 : covers[0].acfHighlightCover) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.covers) === null || ref3 === void 0 ? void 0 : ref3[0], uiColour = ref4.uiColour, uiColourMobile = ref4.uiColourMobile;
                setSliderColour(uiColour);
                setSliderMobileColour(uiColourMobile);
            }
        },
        beforeChange: function(oldIndex, newIndex) {
            var ref, ref1, ref2;
            setProgress(newIndex / (setSliderLength - 1) * 100);
            if (covers === null || covers === void 0 ? void 0 : (ref = covers[newIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.acfHighlightCover) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.covers) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var ref3, ref4;
                var ref5 = (ref3 = covers === null || covers === void 0 ? void 0 : covers[newIndex].acfHighlightCover) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.covers) === null || ref4 === void 0 ? void 0 : ref4[0], uiColour = ref5.uiColour, uiColourMobile = ref5.uiColourMobile;
                setSliderColour(uiColour);
                setSliderMobileColour(uiColourMobile);
            }
        },
        afterChange: function(index) {
            playVideo();
        }
    };
    // NOTE: We should really be using refs instead of query selector
    // to acceess videos.
    var getVideo = function(video) {
        if (video) {
            var promiseVideo = video.play();
            if (promiseVideo !== undefined) {
                promiseVideo.catch(function(error) {
                    console.log("video error: ", error);
                }).then(function() {
                    var ref;
                    sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPause();
                });
            }
        }
    };
    var playVideo = function() {
        if (true) {
            var videos = document.querySelectorAll(".slick-slide.slick-active video");
            getVideo(videos[0], !isDesktop);
            getVideo(videos[1], isDesktop);
        }
    };
    var handleVideoEnded = function() {
        var ref, ref1;
        if (true) {
            var videos = document.querySelectorAll(".slick-slide:not(.slick-active) video");
            // SEL-26 - Some how one user that seems to have this blinking page open forever is now killing sentry because videos.forEach() doesn't exist
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(!videos, NodeList)) {
                return;
            }
            var videoTimeoutId = setTimeout(function() {
                videos.forEach(function(video) {
                    video.load();
                });
            }, 1000);
            setVideoTimeoutId(videoTimeoutId);
        }
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPlay();
    };
    var setLink = function(slug, children) {
        var decideLink = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        return !decideLink && !noLink && slug ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            type: "Highlight",
            href: slug,
            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().link),
            children: children
        }) : children;
    };
    var decideMedia = function(videos, images, className) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().media), className),
            videos: videos,
            videoAutoplay: false,
            videoEnded: function() {
                return handleVideoEnded();
            },
            images: images,
            noLazy: true
        });
    };
    var setContent = function(videosMobile, videosDesktop, images, title, description) {
        var slug = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", decideLink = arguments.length > 6 ? arguments[6] : void 0, gender = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", modelSlug = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().slide),
            children: [
                setLink(slug, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        videosMobile && decideMedia(videosMobile, images, (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mediaMobile)),
                        videosDesktop && decideMedia(videosDesktop, images, (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mediaDesktop))
                    ]
                }), decideLink),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().info),
                    children: [
                        title && modelSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            type: "Model",
                            href: modelSlug,
                            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().link),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().title),
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            })
                        }),
                        description && setLink(slug, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().description),
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }), decideLink)
                    ]
                })
            ]
        }, "".concat(description, "_").concat(title, "_").concat(slug));
    };
    var setVideos = function(mobile, desktop) {
        var mobileUrl = mobile === null || mobile === void 0 ? void 0 : mobile.mediaItemUrl;
        var mobileType = mobile === null || mobile === void 0 ? void 0 : mobile.mimeType;
        var desktopUrl = desktop === null || desktop === void 0 ? void 0 : desktop.mediaItemUrl;
        var desktopType = desktop === null || desktop === void 0 ? void 0 : desktop.mimeType;
        return [
            mobileUrl ? {
                url: mobileUrl,
                type: mobileType
            } : undefined,
            desktopUrl ? {
                url: desktopUrl,
                type: desktopType
            } : undefined, 
        ].filter(function(x) {
            return x !== undefined;
        });
    };
    var setImages = function(mobile, desktop) {
        var mobileUrl = mobile === null || mobile === void 0 ? void 0 : mobile.mediaItemUrl;
        var desktopUrl = desktop === null || desktop === void 0 ? void 0 : desktop.mediaItemUrl;
        return [
            mobileUrl ? {
                url: mobileUrl,
                params: "f_auto"
            } : undefined,
            desktopUrl ? {
                url: desktopUrl,
                params: "f_auto"
            } : undefined, 
        ].filter(function(x) {
            return x !== undefined;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().container), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mainTitleContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mainTitle),
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SliderBlock__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                parentRef: sliderRef,
                setKey: (ref = router.query) === null || ref === void 0 ? void 0 : ref.boardSlug,
                settings: sliderSettings,
                children: covers === null || covers === void 0 ? void 0 : covers.map(function(param, i) {
                    var acfBlocks = param.acfBlocks, acfHighlightCover = param.acfHighlightCover, acfHighlightSettings = param.acfHighlightSettings, slug = param.slug;
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    if (!(acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.covers) || (acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : (ref = acfHighlightCover.covers) === null || ref === void 0 ? void 0 : ref.length) < 1) return null;
                    var ref6 = acfHighlightCover.covers[0], videoMobile = ref6.videoMobile, videoMobileWebm = ref6.videoMobileWebm, videoDesktop = ref6.videoDesktop, videoDesktopWebm = ref6.videoDesktopWebm, imageMobile = ref6.imageMobile, imageDesktop = ref6.imageDesktop;
                    var title = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref1 = acfHighlightSettings.models) === null || ref1 === void 0 ? void 0 : ref1.title;
                    var modelSlug = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref2 = acfHighlightSettings.models) === null || ref2 === void 0 ? void 0 : ref2.slug;
                    var description = acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.shortDescription;
                    var decideLink = ((ref3 = acfBlocks.contentBlocks) === null || ref3 === void 0 ? void 0 : ref3.length) < 1;
                    var gender = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref4 = acfHighlightSettings.models) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.acfModel) === null || ref5 === void 0 ? void 0 : ref5.gender;
                    return setContent(setVideos(videoMobileWebm, videoMobile), setVideos(videoDesktopWebm, videoDesktop), setImages(imageMobile, imageDesktop), title, coverTitle || description, slug, decideLink, gender, title ? modelSlug : null);
                })
            }),
            covers.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().progressBar),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().progressBarIndicator),
                    style: {
                        width: "".concat(progress, "%")
                    }
                })
            })
        ]
    });
}
SliderCover.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    covers: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().array),
    coverTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    noLink: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
};
SliderCover.defaultProps = {
    title: "",
    covers: [],
    coverTitle: "",
    noLink: false,
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SliderCover);


/***/ }),

/***/ 662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClearTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useClearTimeout(id) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            clearTimeout(id);
        };
    }, [
        id
    ]);
}


/***/ }),

/***/ 9828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3825);
/* harmony import */ var components_WordpressSEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1610);
/* harmony import */ var components_SliderCover__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6653);
/* harmony import */ var components_Blocks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4512);
/* harmony import */ var components_ArticlesRelated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1222);
/* harmony import */ var _highlight_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1660);
/* harmony import */ var _highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_highlight_module_css__WEBPACK_IMPORTED_MODULE_8__);










function Highlight(param) {
    var site = param.site, highlight = param.highlight, slug = param.slug, globalSettings = param.globalSettings;
    var title = highlight.title, acfHighlightCover = highlight.acfHighlightCover, acfHighlightSettings = highlight.acfHighlightSettings, acfBlocks = highlight.acfBlocks;
    var models = acfHighlightSettings.models, globalBrandTag = acfHighlightSettings.globalBrandTag, globalCampaignTag = acfHighlightSettings.globalCampaignTag, globalCategoriesTag = acfHighlightSettings.globalCategoriesTag, globalPhotographerTag = acfHighlightSettings.globalPhotographerTag, globalPublicationTag = acfHighlightSettings.globalPublicationTag, globalStylistTag = acfHighlightSettings.globalStylistTag;
    var setSidebarItems = [
        globalBrandTag[0],
        globalCampaignTag[0],
        globalCategoriesTag[0],
        globalPhotographerTag[0],
        globalPublicationTag[0],
        globalStylistTag[0], 
    ];
    var relatedPosts = models === null || models === void 0 ? void 0 : models.relatedPosts;
    var setCovers = [
        {
            acfBlocks: acfBlocks,
            acfHighlightCover: {
                shortDescription: acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.shortDescription,
                covers: acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.covers
            },
            acfHighlightSettings: acfHighlightSettings,
            slug: slug
        }, 
    ];
    var setSidebarItem = function(label, name) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().label),
                    dangerouslySetInnerHTML: {
                        __html: label
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: (_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().name),
                    dangerouslySetInnerHTML: {
                        __html: name
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WordpressSEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                url: "/".concat(site, "/highlight/").concat(slug),
                title: highlight.title,
                seo: highlight.seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SliderCover__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                covers: setCovers,
                noLink: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().blocks),
                        children: acfBlocks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Blocks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            postType: "Highlight",
                            children: acfBlocks
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().sidebar),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().label), (_highlight_module_css__WEBPACK_IMPORTED_MODULE_8___default().labelMobile)),
                                dangerouslySetInnerHTML: {
                                    __html: "Credits"
                                }
                            }),
                            models && setSidebarItem(models.__typename, models.title),
                            title && setSidebarItem("Title", title),
                            setSidebarItems.map(function(item) {
                                if (!item) return null;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: setSidebarItem(item.__typename, item.name)
                                }, item.name);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticlesRelated__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                articles: relatedPosts
            })
        ]
    });
}
Highlight.propTypes = {
    site: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    highlight: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().object),
    globalSettings: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().object)
};
Highlight.defaultProps = {
    site: "",
    slug: "",
    highlight: null,
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Highlight);


/***/ }),

/***/ 9305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticlesRelated_spacing--xxxs__HwmnX","spacing--xxs":"ArticlesRelated_spacing--xxs___LKEs","spacing--xs":"ArticlesRelated_spacing--xs__5lJr5","spacing--sm":"ArticlesRelated_spacing--sm__bOnZw","spacing--md":"ArticlesRelated_spacing--md__H8nvn","spacing--lg":"ArticlesRelated_spacing--lg__NbATD","spacing--xl":"ArticlesRelated_spacing--xl__paO_V","spacing--xxl":"ArticlesRelated_spacing--xxl__mFWiY","spacing--xxxl":"ArticlesRelated_spacing--xxxl__ddWi4","container":"ArticlesRelated_container__TKTXC","wrapper":"ArticlesRelated_wrapper__o2xSe","project":"ArticlesRelated_project__4ZyZ5","imgWrap":"ArticlesRelated_imgWrap__DBe88","img":"ArticlesRelated_img__hlfxd","title":"ArticlesRelated_title__OLP1_","subtitle":"ArticlesRelated_subtitle__e4AxV","fadeInItems":"ArticlesRelated_fadeInItems__Oveg4"};

/***/ }),

/***/ 7764:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"SliderCover_spacing--xxxs__iTqjK","spacing--xxs":"SliderCover_spacing--xxs__egwaf","spacing--xs":"SliderCover_spacing--xs__SOxLb","spacing--sm":"SliderCover_spacing--sm__SX4yx","spacing--md":"SliderCover_spacing--md__3HmPV","spacing--lg":"SliderCover_spacing--lg__DhAWQ","spacing--xl":"SliderCover_spacing--xl__0HHQy","spacing--xxl":"SliderCover_spacing--xxl__3jSb0","spacing--xxxl":"SliderCover_spacing--xxxl__0Y4_u","container":"SliderCover_container__d975A","media":"SliderCover_media__JFSSf","mediaMobile":"SliderCover_mediaMobile__IwxPg","mediaDesktop":"SliderCover_mediaDesktop__FXPIt","link":"SliderCover_link__TJc_r","info":"SliderCover_info__MYH7r","mainTitleContainer":"SliderCover_mainTitleContainer__IBGLI","mainTitle":"SliderCover_mainTitle__FXnyj","title":"SliderCover_title__p3AWD","description":"SliderCover_description__Msijt","progressBar":"SliderCover_progressBar__PNbyG","progressBarIndicator":"SliderCover_progressBarIndicator__RWFiS","fadeInItems":"SliderCover_fadeInItems__T0O7m"};

/***/ }),

/***/ 1660:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"highlight_spacing--xxxs__0yo00","spacing--xxs":"highlight_spacing--xxs__GtGkx","spacing--xs":"highlight_spacing--xs__rLPbJ","spacing--sm":"highlight_spacing--sm__5BmBH","spacing--md":"highlight_spacing--md__BnWqK","spacing--lg":"highlight_spacing--lg__O7oW8","spacing--xl":"highlight_spacing--xl__LYN_X","spacing--xxl":"highlight_spacing--xxl__yltq_","spacing--xxxl":"highlight_spacing--xxxl__rdUCT","container":"highlight_container__SGwRM","blocks":"highlight_blocks__Lh6fV","sidebar":"highlight_sidebar__5m_lm","label":"highlight_label__LNbpY","name":"highlight_name__m3Jd2","labelMobile":"highlight_labelMobile__uGzEd","fadeInItems":"highlight_fadeInItems__BVPpX"};

/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,66,529,895,774,888,179], function() { return __webpack_exec__(1740); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);